import t from "./text-input.vue2.js";
import "./text-input.vue3.js";
import "./text-input.vue4.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const a = /* @__PURE__ */ o(t, [["__scopeId", "data-v-8ffa7794"]]);
export {
  a as default
};
//# sourceMappingURL=text-input.vue.js.map
